import type {
  SimulationColumns,
  SimulationLineAnalyzerColumns,
  SortSimulationLineAnalyzerColumn
} from '@library/types/simulations';
import type { TableColumn } from '@library/types/utils';
import bet365 from '@library/assets/images/icons/company_logos/bet365.png';
import betmgm from '@library/assets/images/icons/company_logos/betmgm.png';
import circa from '@library/assets/images/icons/company_logos/circa.png';
import draftkings from '@library/assets/images/icons/company_logos/draftkings.png';
import fanduel from '@library/assets/images/icons/company_logos/fanduel.png';
import pinnacle from '@library/assets/images/icons/company_logos/pinnacle.jpg';
import prizepicks from '@library/assets/images/pp-logos/pp-logo.png';
import underdog from '@library/assets/images/icons/company_logos/underdog.png';

export const DEFAULT_SIMULATIONS_LINE_ANALYZER_SORT: SortSimulationLineAnalyzerColumn =
  {
    sortBy: 'team',
    sortDirection: 'asc'
  };

export const SIMULATIONS_HEADER: Array<TableColumn<SimulationColumns>> = [
  {
    column: 'id',
    essential: true,
    label: 'Id',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: false,
    width: 'w-1/2'
  },
  {
    column: 'status',
    essential: true,
    label: 'Status',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'type',
    essential: true,
    label: 'Type',
    sortEnabled: false,
    width: 'w-1/6'
  }
];

export const SIMULATIONS_LINE_ANALYZER_HEADER: Array<
  TableColumn<SimulationLineAnalyzerColumns>
> = [
  /*
  {
    column: 'player_id',
    essential: true,
    label: 'Player Id',
    sortEnabled: true,
    width: 'w-40'
  }, */
  {
    column: 'sport_radar_id',
    essential: true,
    label: 'Sport Radar Id',
    sortEnabled: true,
    width: 'w-40'
  },
  {
    column: 'player_name',
    essential: true,
    label: 'Player Name',
    sortEnabled: true,
    width: 'w-36'
  },
  {
    column: 'stat',
    essential: true,
    label: 'Stat',
    sortEnabled: true,
    width: 'w-80'
  },
  {
    column: 'line_type',
    essential: true,
    label: 'Line Type',
    sortEnabled: true,
    width: 'w-24'
  },
  {
    column: 'line',
    essential: true,
    label: 'Line',
    sortEnabled: true,
    width: 'w-24'
  },
  {
    column: 'draft_kings',
    essential: true,
    icon: draftkings,
    label: 'DraftKings',
    sortEnabled: false,
    width: 'w-20'
  },
  {
    column: 'fan_duel',
    essential: true,
    icon: fanduel,
    label: 'FanDuel',
    sortEnabled: false,
    width: 'w-20'
  },
  {
    column: 'under_dog',
    essential: true,
    icon: underdog,
    label: 'UnderDog',
    sortEnabled: false,
    width: 'w-20'
  },
  {
    column: 'pinnacle',
    essential: true,
    icon: pinnacle,
    label: 'Pinnacle',
    sortEnabled: false,
    width: 'w-20'
  },
  {
    column: 'bet_365',
    essential: true,
    icon: bet365,
    label: 'Bet 365',
    sortEnabled: false,
    width: 'w-20'
  },
  {
    column: 'bet_mgm',
    essential: true,
    icon: betmgm,
    label: 'Bet MGM',
    sortEnabled: false,
    width: 'w-20'
  },
  {
    column: 'circa',
    essential: true,
    icon: circa,
    label: 'Circa',
    sortEnabled: false,
    width: 'w-20'
  },
  {
    column: 'current_prizepicks_line',
    essential: true,
    icon: prizepicks,
    label: 'Current Prizepicks Line',
    sortEnabled: false,
    width: 'w-20'
  }
];
